package com.partejar.app.core.ui.components

import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.semantics.clearAndSetSemantics
import com.partejar.app.core.ui.theme.PartejarShapes

private const val SkeletonStaticAlpha = 0.72f
private const val SkeletonPulseFrom = 0.56f
private const val SkeletonPulseTo = 0.84f

@Composable
fun PartejarSkeleton(
    modifier: Modifier,
    shape: Shape = MaterialTheme.shapes.small
) {
    val reduced = reducedMotion()
    val alpha = if (reduced) {
        SkeletonStaticAlpha
    } else {
        val transition = rememberInfiniteTransition(label = "partejarSkeleton")
        val value by transition.animateFloat(
            initialValue = SkeletonPulseFrom,
            targetValue = SkeletonPulseTo,
            animationSpec = infiniteRepeatable(
                animation = tween(PartejarMotion.skeletonPulse, easing = PartejarMotion.calm),
                repeatMode = RepeatMode.Reverse
            ),
            label = "partejarSkeletonAlpha"
        )
        value
    }

    Box(
        modifier = modifier
            .clip(shape)
            .background(MaterialTheme.colorScheme.surfaceContainerHighest.copy(alpha = alpha))
            .clearAndSetSemantics { }
    )
}

@Composable
fun PartejarSkeletonText(
    modifier: Modifier,
    shape: Shape = PartejarShapes.pill
) {
    PartejarSkeleton(modifier = modifier, shape = shape)
}
